/* import __COLOCATED_TEMPLATE__ from './flash-messages.hbs'; */
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { FlashMessages } from 'register-partners-js/react/components/flash-messages';

export default class FlashMessagesComponent extends Component {
  @service toastFlashMessages;

  flashMessages = FlashMessages;
}
